var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "report-ticket" } }, [
    _c("div", { staticClass: "overall-content" }, [
      _c(
        "div",
        { staticClass: "chart-container" },
        [
          _c(
            "div",
            { staticClass: "chart-section" },
            [
              _c("h2", [_vm._v(_vm._s(_vm.$t("report.ticketCountByUser")))]),
              _vm._v(" "),
              _c("TicketDistributionsByUser", {
                attrs: {
                  filters: _vm.filters,
                  loading: _vm.loading,
                  data: _vm.data.byUser,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("a-divider"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "chart-section" },
            [
              _c("h2", [_vm._v(_vm._s(_vm.$t("report.ticketCountByStatus")))]),
              _vm._v(" "),
              _c("TicketDistributionsByStatus", {
                attrs: {
                  filters: _vm.filters,
                  loading: _vm.loading,
                  data: _vm.data.byStatus,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("a-divider"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "chart-section" },
            [
              _c("h2", [_vm._v(_vm._s(_vm.$t("report.ticketCountByStatus")))]),
              _vm._v(" "),
              _c("TicketCountTimeSeriesChart", {
                attrs: {
                  filters: _vm.filters,
                  loading: _vm.loading,
                  data: _vm.data.timeSeries,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }